module.exports = __webpack_public_path__ + "img/semipublic.43c273b5.svg";